import React, { useMemo } from 'react';

import { Check, XIcon } from 'lucide-react';
import { Control, useWatch } from 'react-hook-form';

interface PasswordValidationProps {
  control: Control<any>;
}

interface ValidationItemProps {
  isValid: boolean;
  text: string;
}

const ValidationItem: React.FC<ValidationItemProps> = ({ isValid, text }) => (
  <div className="flex flex-row items-center gap-1">
    {isValid ? <Check className="h-4 w-4" color="#2B9A66" /> : <XIcon className="h-4 w-4" color="#FF0000" />}
    <p className={`text-sm font-normal ${isValid ? 'text-green-600' : 'text-red-600'}`}>{text}</p>
  </div>
);

const PasswordValidation: React.FC<PasswordValidationProps> = ({ control }) => {
  const password = useWatch({
    control,
    name: 'password',
  });

  const validations = useMemo(() => {
    const hasMinLength = password.length >= 7;
    const hasUpperAndLowerCase = /[a-z]/.test(password) && /[A-Z]/.test(password);
    const hasNumberOrSpecialChar = /[!@#$%^&*(),.?":{}|<>_+=\-/0-9]/.test(password);

    return {
      minLength: hasMinLength,
      upperAndLowerCase: hasUpperAndLowerCase,
      numberOrSpecialChar: hasNumberOrSpecialChar,
    };
  }, [password]);

  return (
    <div>
      <ValidationItem isValid={validations.minLength} text="7 or more characters" />
      <ValidationItem isValid={validations.upperAndLowerCase} text="Upper & lowercase characters" />
      <ValidationItem isValid={validations.numberOrSpecialChar} text="At least one number or special character" />
    </div>
  );
};

export default PasswordValidation;
